import {
    CREATE_TRANSACTION_PAYMENT,
    CREATE_TRANSACTION_PAYMENT_FAILURE,
    CREATE_TRANSACTION_PAYMENT_SUCCESS,
    FETCH_TRANSACTION_QUOTES,
    FETCH_TRANSACTION_QUOTES_FAILURE,
    FETCH_TRANSACTION_QUOTES_SUCCESS,
    SELECT_TRANSACTION_QUOTE,
} from 'store/actions/types';

const initialState = {
    link: null,
    loading: false,
    message: null,
    prices: {},
    quotes: [],
    selected: null,
    transaction: null,
};

export const getSelectedQuote = (state) => {
    const {
        quotes,
        selected,
    } = state.transactions;

    const selectedQuote = quotes[selected];

    return selectedQuote ? selectedQuote : null;
};

export default function transactions(state = initialState, action) {
    switch (action.type) {
        case CREATE_TRANSACTION_PAYMENT:
        case FETCH_TRANSACTION_QUOTES:
            return Object.assign({}, state, {
                loading: true,
            });

        case CREATE_TRANSACTION_PAYMENT_FAILURE:
        case FETCH_TRANSACTION_QUOTES_FAILURE:
            return Object.assign({}, state, {
                loading: false,
            });

        case FETCH_TRANSACTION_QUOTES_SUCCESS:
            return Object.assign({}, state, {
                quotes: action.response,
            });
        case CREATE_TRANSACTION_PAYMENT_SUCCESS:
            return Object.assign({}, state, {
                link: action.response.payment_url,
            });
        case SELECT_TRANSACTION_QUOTE:
            return Object.assign({}, state, {
                selected: action.selected,
            });

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/store/reducers/transactionsReducer.js